
let BoxPlugin = {};

BoxPlugin.install = function (Vue, options) {

    Vue.prototype.$showAlert = function(content, onClose) {
        this.$alert(content, {
            confirmButtonText: '确定',
            callback: action => {
                if (onClose) {
                    onClose();
                }
            }
        });
    }

    Vue.prototype.$showMessage = function(type, content, isHtml, time, onClose) {
        return this.$message({
            message: content,
            duration: time ? time : 2000,
            type: type,
            offset: 400,
            dangerouslyUseHTMLString: isHtml,
            onClose: () => {
                if (onClose) {
                    onClose();
                }
            }
        })
    }

    Vue.prototype.$showSuccess = function(content, time, onClose) {
        return this.$showMessage("success", content, false, time, onClose);
    }

    Vue.prototype.$showError = function(content, time, onClose) {
        return this.$showMessage("error", content, false, time, onClose);
    }

    Vue.prototype.$showWarn = function(content, time, onClose) {
        return this.$showMessage("warning", content, false, time, onClose);
    }

    Vue.prototype.$showInfo = function(content, time, onClose) {
        return this.$showMessage("info", content, false, time, onClose);
    }




    Vue.prototype.$showConfirm = function (content, success, cancel) {
        this.$confirm(content, "确认", {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            if (success) {
                success();
            }
        }).catch(() => {
            if (cancel) {
                cancel();
            }
        })
    }


    Vue.prototype.$showPrompt = function (title, content, success, cancel) {
        this.$prompt(title, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputValue: content,
        }).then(({ value }) => {
            if (success) {
                success(value);
            }
        }).catch(() => {
            if (cancel) {
                cancel();
            }

        });
    }

}

export default BoxPlugin;
